import React from 'react';
import SectionHeader from '../SectionHeader';
import Infographic from '../Infographic';
import trans from '../../translations.json';
import Regiona from '../regional/regionalIndex';
import Phu from '../phu/phuIndex';
import Tabs from '../tabs/tabs';
import CasesTotal from '../casesTotal';
import CasesTotalTable from '../casesTotal-table';

import BySourceSetting from '../bySourceSetting/bySourceSettingIndex';
import BySourceAll from '../bySourceAll/bySourceAllIndex';

import CasesDaily from '../casesDaily';
import CasesDailyTable from '../casesDaily-table';

import DeathsTotal from '../deathsTotal';
import DeathsTotalTable from '../deathsTotal-table';

import DeathsDaily from '../deathsDaily';
import DeathsDailyTable from '../deathsDaily-table';

import EffectiveReproduction from '../EffectiveReproduction';
import EffectiveReproductionTable from '../EffectiveReproduction-Table';

import CasesByAge from '../casesByAge';
import CasesByAgeTable from '../casesByAge-table';
import CasesByAgePie from '../CasesByAge-pie';

import Gender from '../gender/genderIndex';
import ActiveOutbreaks from '../activeOutbreaks/activeOutbreaks';
import ActiveOutbreaksTable from '../activeOutbreaks/activeOutbreaks-table';

const CasesByNumbers = (props) => {
  return (
    <SectionHeader
      id="case_numbers_and_spread"
      title={trans.otp.byNumbers}
      lastUpdated={props.lastUpdated}
      lang={props.lang}
    >
      <div className="ontario-row">
        <Infographic
          id=""
          lang={props.lang}
          defaultSelection="chart"
          width="full"
          titleDesc={{
            title: trans.reg.title,
          }}
          opts={['chart']}
          chart={<Regiona lang={props.lang} />}
        />

        <Infographic
          id=""
          lang={props.lang}
          defaultSelection="chart"
          width="full"
          titleDesc={trans.phu}
          desc={trans.phu.desc}
          opts={['chart']}
          chart={<Phu lang={props.lang} selectedTab="newCases" />}
        />
      </div>

      {/* <Tabs
        lang={props.lang}
        newCases={
          <Phu lang={props.lang} selectedTab="newCases" />
        }
        totalCases={
          <Phu lang={props.lang} selectedTab="totalCases" />
        }
      /> */}

      {/* 
      <FsaMap
        lang={props.lang}
        startColor={[224, 216, 193]}
        endColor={[224, 72, 7]}
      /> */}

      <div className="ontario-row ">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.casesDaily.title[props.lang]}</h3>
          <Tabs
            lang={props.lang}
            newCases={
              <Infographic
                id="CasesDaily"
                lang={props.lang}
                //titleDesc={trans.casesDaily}
                bar={
                  <CasesDaily
                    lang={props.lang}
                    chartTitle={trans.casesDaily.title[props.lang]}
                  />
                }
                table={<CasesDailyTable lang={props.lang} />}
                width="default"
              />
            }
            totalCases={
              <Infographic
                id="CasesTotal"
                lang={props.lang}
                // titleDesc={trans.casesTotal}
                bar={
                  <CasesTotal
                    lang={props.lang}
                    chartTitle={trans.casesTotal.title[props.lang]}
                  />
                }
                table={<CasesTotalTable lang={props.lang} />}
                width="default"
              />
            }
          />
        </div>
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.deathsTotal.title[props.lang]}</h3>
          <Tabs
            lang={props.lang}
            newCases={
              <Infographic
                id="DeathsDaily"
                lang={props.lang}
                //titleDesc={trans.deathsDaily}
                bar={
                  <DeathsDaily
                    lang={props.lang}
                    chartTitle={trans.deathsDaily.title[props.lang]}
                  />
                }
                table={<DeathsDailyTable lang={props.lang} />}
                width="default"
              />
            }
            totalCases={
              <Infographic
                id="DeathsTotal"
                lang={props.lang}
                //titleDesc={trans.deathsTotal}
                bar={
                  <DeathsTotal
                    lang={props.lang}
                    chartTitle={trans.deathsTotal.title[props.lang]}
                  />
                }
                table={<DeathsTotalTable lang={props.lang} />}
                width="default"
              />
            }
          />
          {/* <span className="cviz-popup-status">
            <div style={{backgroundColor: '#9A76B9', marginRight: '5px'}}></div>
            <p dangerouslySetInnerHTML={{__html: trans.heatmap.dataAnomalies[props.lang] }} ></p>
          </span> */}
        </div>
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>
            {trans.overview.reproduction.graphTitle[props.lang]}
          </h3>
          <p
            dangerouslySetInnerHTML={{
              __html:
                trans.overview.reproduction.aboutRe[props.lang] +
                ' ' +
                trans.overview.reproduction.descB[props.lang],
            }}
          ></p>
          <p
            dangerouslySetInnerHTML={{
              __html:
                trans.overview.reproduction.graphDesc[props.lang],
            }}
          ></p>
          <Infographic
            id="Re"
            lang={props.lang}
            bar={
              <EffectiveReproduction
                lang={props.lang}
                chartTitle={
                  trans.overview.reproduction.graphTitle[props.lang]
                }
              />
            }
            table={<EffectiveReproductionTable lang={props.lang} />}
            width="default"
          />
        </div>
      </div>

      <div className="ontario-row">
        <Infographic
          id="CasesByAge"
          lang={props.lang}
          titleDesc={{
            title: trans.casesByAge.title,
            desc: trans.reg.desc,
          }}
          opts={['bar', 'table', 'pie']}
          bar={
            <CasesByAge
              lang={props.lang}
              chartTitle={trans.casesByAge.title[props.lang]}
            />
          }
          table={<CasesByAgeTable lang={props.lang} />}
          pie={<CasesByAgePie lang={props.lang} />}
        />

        <Infographic
          id="Gender"
          lang={props.lang}
          titleDesc={{
            title: trans.CasesByGender.title,
            desc: trans.CasesByGender.descB,
          }}
          opts={['bar', 'table', 'pie']}
          bar={
            <Gender
              lang={props.lang}
              chartTitle={trans.CasesByGender.title[props.lang]}
            />
          }
        />
      </div>

      <div className="ontario-row ">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.bySource.bySourcesTitle[props.lang]}</h3>
          <h4>{trans.bySource.titleAllSources[props.lang]}</h4>
          <Infographic
            id="bySource"
            lang={props.lang}
            bar={
              <Tabs
                lang={props.lang}
                newCases={
                  <BySourceAll
                    lang={props.lang}
                    selectedTab="newCases"
                  />
                }
                totalCases={
                  <BySourceAll
                    lang={props.lang}
                    selectedTab="totalCases"
                  />
                }
              />
            }
            width="default"
          />
        </div>
      </div>

      <div className="ontario-row ">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h4>{trans.bySource.title[props.lang]}</h4>
          <Infographic
            id="byLikelySource"
            lang={props.lang}
            bar={
              <Tabs
                lang={props.lang}
                newCases={
                  <BySourceSetting
                    lang={props.lang}
                    selectedTab="newCases"
                  />
                }
                totalCases={
                  <BySourceSetting
                    lang={props.lang}
                    selectedTab="totalCases"
                  />
                }
              />
            }
            width="default"
          />
        </div>
      </div>

      <div className="ontario-row ">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h4>{trans.activeOutbreaks.title[props.lang]}</h4>
          <Infographic
            id="ActiveOutbreaks"
            lang={props.lang}
            opts={['bar', 'table']}
            bar={
              <ActiveOutbreaks
                lang={props.lang}
                chartTitle={trans.casesByAge.title[props.lang]}
              />
            }
            table={<ActiveOutbreaksTable lang={props.lang} />}
            width="default"
          />
        </div>
      </div>
    </SectionHeader>
  );
};

export default CasesByNumbers;
